/* eslint-disable max-len */
import React,{useRef,useEffect} from 'react'
import { BrowserRouter, Link, useLocation } from 'react-router-dom'
import { CDN } from '../../../constants';
import { WishlistExist } from '../../../redux/helper/AddWishlist';

export default function RelatedProducts({elRef,Products,wishlistProduct,handleAddToWishList,setmodalType,setselectedItem,Cart,setCartId}) {
  
    const imageUrl =(Product)=> Product.IMAGE_NAME?`${CDN}/product-images/${Product.IMAGE_NAME}`:'/images/gen.png';
    return (
        <>
            <div className="carousel-inner relative w-full overflow-hidden">
                <div className='carousel-item active relative float-left w-full'>
                    <div className="flex pr-[20px]" style={{overflowX:'auto',scrollbarColor:'transparent',scrollBehavior:'smooth'}} ref = {elRef} >
                        {Products && Products.map((val,i)=>(
                            <>
                                <div key={val.INVENTORY_ITEM_ID} className={`${i===0?'sm:ml-8':''} ml-6 min-w-[400px] max-w-[400px] border border-[#E1E1E1] rounded-lg p-2.5`}>
                                    <div className="flex relative h-full">
                                        <Link to={`/products/${val.INVENTORY_ITEM_ID}/view`}>
                                            <img src={imageUrl(val)} alt="icon"  onClick={()=>{
                                                window.location.href=`/products/${val.INVENTORY_ITEM_ID}/view`
                                            }} style={{width:'116px',heigh:'88px',objetFit:'cover'}}/>
                                        </Link>
                                        <div className="pl-5 w-full">
                                            <div className='flex justify-between flex-col h-full'>
                                                <div>
                                                    {/* <Link to={`/products/${val.INVENTORY_ITEM_ID}/view`}> */}
                                                    <div className='flex'>
                                                        <p onClick={()=>{
                                                            window.location.href=`/products/${val.INVENTORY_ITEM_ID}/view`
                                                        }} className="font-semibold text-base text-[#090406] w-[93%] pr-1">{val?.MODEL_DESCRIPTION || `${val?.DESCRIPTION.length > 10 ? `${val.DESCRIPTION.slice(0,10)}...`:`${val.DESCRIPTION}`}`}</p>
                                                        <div className='w-[7%] self-start'>
                                                            <button type="button" data-bs-toggle="modal" data-bs-target="#exampleModalCenter2"  
                                                                onClick={()=>{
                                                                    setmodalType('popup');
                                                                    setselectedItem(val)
                                                                }}>
                                                                <img src={WishlistExist(wishlistProduct,val.INVENTORY_ITEM_ID)?'/images/heart_active.svg':'/images/Iconawesome-heart.svg'} alt="" 
                                                                    className="w-full" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                    {/* </Link> */}
                                                    <p className="font-regular text-[#808285] text-xs3">Product Code: {val?.CONCATENATED_SEGMENTS} <span className="pl-1">AWS: {val?.AWS_CLASSIFICATION}</span></p>
                                                </div>
                                                <button 
                                                    onClick={()=>setCartId(val)}
                                                    className="cursor-pointer bg-[#555259] rounded-lg text-[#FFFFFF] font-semibold text-xs13 w-full py-[9px] mt-2">
                                                    <>{WishlistExist(Cart,val?.INVENTORY_ITEM_ID)?'Added to Cart!':'Add to Cart'}</> 
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}
